<script setup>
import { computed } from "vue";
import { n } from "components/jiffy/vue-cart/helpers/currency";

const props = defineProps({
  min: {
    type: Number,
    default: 0
  },
  max: {
    type: Number,
    required: true
  },
  value: {
    type: Number,
    required: true
  },
  label: {
    type: String,
    required: true
  }
});

const percentage = computed(() => {
  if (props.value <= props.min) return "0";
  if (props.value >= props.max) return "100%";
  const result = (props.value - props.min) / (props.max - props.min);
  return `${Math.round(result * 100)}%`;
});

const amountLeft = computed(() => Math.max(props.max - props.value, 0));
</script>

<template>
  <div v-if="amountLeft > 0" class="money-progress">
    <div class="money-progress__wrapper">
      <div class="money-progress__tier money-progress__tier--min">
        {{ n(min, "currencyNoCents") }}
      </div>
      <div class="money-progress__line">
        <div class="money-progress__bar" :style="{ width: percentage }" />
      </div>
      <div class="money-progress__tier money-progress__tier--max">
        {{ n(max, "currencyNoCents") }}
      </div>
    </div>
    <div class="money-progress__label">
      {{ n(amountLeft, "currencyNoCents") }} until {{ label }}
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/pod/settings";

.money-progress {
  margin: 0 18px;

  &__wrapper {
    display: flex;
    align-items: center;
    height: 16px;
    width: 100%;
    color: $pod-gray-modern-900;
  }

  &__tier {
    display: inline-block;
    font-size: 13px;
    font-weight: 500;
  }

  &__line {
    display: inline-block;
    position: relative;
    width: 100%;
    height: 4px;
    background: $pod-gray-modern-200;
    margin: 0 6px;
    border-radius: 6px;
    overflow: hidden;
  }

  &__bar {
    position: absolute;
    left: 0;
    max-width: 100%;
    height: 100%;
    background: $blue;
    transition: width 0.5s ease;
  }

  &__label {
    font-size: 12px;
    font-weight: 500;
    color: $pod-gray-modern-600;
    text-align: center;
    font-family: Inter, sans-serif;
  }
}
</style>
